import React from 'react';
import { Table } from '@zillow/constellation';
import { StyledSortableHeaderCell } from './StyledSortableHeaderCell';

export const CompletedTaskHeaders = () => {
  return (
    <Table.Row>
      <Table.HeaderCell>&nbsp;</Table.HeaderCell>
      <Table.SortableHeaderCell id={'taskName'}>Task</Table.SortableHeaderCell>
      <Table.SortableHeaderCell id={'role'}>Role</Table.SortableHeaderCell>
      <StyledSortableHeaderCell id={'assignedTo'}>Completed By</StyledSortableHeaderCell>
      <StyledSortableHeaderCell id={'dueDate'} minWidth={200}>
        Completed At
      </StyledSortableHeaderCell>
    </Table.Row>
  );
};
